import { format } from 'libphonenumber-js';
import * as options from 'features/profile/experience-questions/experienceOptions';
import * as edOptions from 'features/profile/education-questions/options';
import isUndefined from 'lodash/isUndefined';

const getExperience = (user, t) => {
  const data = [];
  options.priorExperienceOptions.forEach((option) => {
    if (user[option.key]) {
      data.push(t(option.label));
    }
  });
  return data.join(', ');
};

const getNrOfTestslabel = (value, t) => {
  const foundOption = options.testsAdministrationOptions.find((option) => option.value === value);
  return foundOption ? t(foundOption.label) : '';
};

const getJobResponsibility = (user, t) => {
  const data = [];
  edOptions.responsibilitiesOptions.forEach((option) => {
    if (user[option.key]) {
      data.push(t(option.label));
    }
  });
  if (user.otherJobFlag) {
    data.push(user.otherJobDesc);
  }
  return data.join(', ');
};

const contactInfo = (user, t) => [
  {
    data: user.lastName,
    label: t('forms.labels.lastName'),
  },
  {
    data: user.firstName,
    label: t('forms.labels.firstName'),
  },
  {
    data: user.address1,
    label: t('forms.labels.address'),
  },
  {
    data: user.city,
    label: t('forms.labels.city'),
  },
  {
    data: user.stateCode,
    label: t('forms.labels.stateProvince'),
  },
  {
    data: user.postalCode,
    label: t('forms.labels.zip'),
  },
  {
    data: user.cellPhone ? format(user.cellPhone, 'US', 'National') : '',
    label: t('forms.labels.cellPhone'),
  },
  {
    data: user.workPhone
      ? `${format(user.workPhone, 'US', 'National')}${
          user.workPhoneExt ? `,${user.workPhoneExt}` : ''
        }`
      : '',
    label: t('forms.labels.workPhone'),
  },
  {
    data: user.emailAddress,
    label: t('common.labels.email'),
  },
];

const pastInfo = (user, t) => [
  {
    data: user ? getExperience(user, t) : '',
    label: t('profile.pastExperience.priorExperienceLabel'),
  },
  {
    data: user.previouslyAdministeredTests ? user.previouslyAdministeredTests : '',
    label: t('profile.pastExperience.standardizedTestLabel'),
  },
  {
    data: user.taAdminCount ? getNrOfTestslabel(user.taAdminCount, t) : '',
    label: t('profile.pastExperience.testsAdministrationLabel'),
  },
  {
    data: user.totalTestingExp,
    label: t('profile.pastExperience.experienceLabel'),
  },
  {
    data: user.firstActYear || '',
    label: t('profile.pastExperience.firstTestLabel'),
  },
];

const demographicInfo = (user, t) => [
  {
    data: user.usCitizenFlag ? t('common.labels.yes') : t('common.labels.no'),
    label: t('profile.background.labelUSCitizen'),
  },
];

const educationInfo = (user, t) => [
  {
    data: user.educationLevel ? user.educationLevel.level : '',
    label: t('profile.background.labelEducationLevel'),
  },
  {
    data: user ? getJobResponsibility(user, t) : '',
    label: t('profile.background.labelJobResponsibilities'),
  },
];

const allInfo = (user, t) =>
  contactInfo(user, t).concat(pastInfo(user, t), demographicInfo(user, t), educationInfo(user, t));

export function setContactInfo(user, t) {
  return contactInfo(user, t);
}

export function setDemographicInfo(user, t) {
  return demographicInfo(user, t);
}

export function setEducationInfo(user, t) {
  return educationInfo(user, t);
}

export function setPastInfo(user, t) {
  return pastInfo(user, t);
}

export function getTotalInfo(user, t) {
  return allInfo(user, t).length;
}

export function getCompletedInfo(user, t) {
  return allInfo(user, t).reduce((accumulator, element) => {
    if (isUndefined(element.data) || element.data === '') {
      return accumulator;
    }
    return ++accumulator;
  }, 0);
}
